export default __webpack_public_path__ + "static/media/ic-cirle-full.7b1d4e01.svg";